import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const PasscodeForm = () => {
  const navigate = useNavigate();

  const onPrimaryButtonContainerClick = useCallback(() => {
    navigate("/signup1");
  }, [navigate]);

  return (
    <div className="rounded-4xl bg-light flex flex-col py-16 px-8 items-center justify-start gap-[64px] text-center text-28xl text-dark font-footnote border-b-[4px] border-solid border-lavender">
      <div className="flex flex-col items-center justify-start">
        <b className="relative leading-[40px]">Enter Passcode</b>
      </div>
      <div className="self-stretch flex flex-col items-center justify-start gap-[32px]">
        <input
          className="font-medium font-h2-accent text-8xl bg-sky-blue-100 self-stretch rounded-25xl flex flex-col py-4 pr-0 pl-4 items-center justify-between border-[1px] border-solid border-darkslategray-200"
          type="number"
          placeholder="Enter 7 Digit Passcode"
        />
        <button className="cursor-pointer [border:none] p-0 bg-[transparent] relative text-base font-bold font-footnote text-dark text-left inline-block hover:text-darkslategray-300">
          Resend Code
        </button>
      </div>
      <div
        className="self-stretch rounded-31xl bg-gold flex flex-row py-[22px] px-8 items-center justify-center cursor-pointer text-left text-5xl hover:bg-goldenrod-100"
        onClick={onPrimaryButtonContainerClick}
      >
        <b className="relative">Sign in</b>
      </div>
    </div>
  );
};

export default PasscodeForm;
